export default {"src":"/_next/static/media/profile-weakness.b68301fd.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};